<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  :action="actionUrl"
  id="newsletterTypeForm"
  v-on:submit.prevent="submit"
>
  <div class="form-group">
    <label for="newsletter-type-name">
      Name
    </label>
    <input
      type="text"
      name="newsletter_type[name]"
      id="newsletter-type-name"
      v-model="name"
      class="form-control"
      required
    />
  </div>

  <div class="form-group">
    <label for="newsletter-type-default-reply-email">
      Default Reply Email Address
    </label>
    <input
      type="text"
      name="newsletter_type[default_reply_email]"
      id="newsletter-type-default-reply-email"
      v-model="default_reply_email"
      class="form-control"
    />
  </div>

  <div class="form-group">
    <label for="newsletter-type-slug">
      Slug
    </label>
    <input
      type="text"
      name="newsletter_type[slug]"
      id="newsletter-type-slug"
      v-model="slug"
      class="form-control"
    />
  </div>

  <div class="form-group">
    <label for="newsletter-type-description">
      Description
    </label>
    <textarea
      name="newsletter_type[description]"
      id="newsletter-type-description"
      v-model="description"
      class="form-control"
    ></textarea>
  </div>

  <div class="form-group">
    <label for="newsletter-type-header-html">
      Header (Accepts HTML)
    </label>
    <textarea
      name="newsletter_type[header_html]"
      id="newsletter-type-header-html"
      v-model="header_html"
      class="form-control"
    ></textarea>
  </div>

  <div class="form-group">
    <label for="newsletter-type-footer-html">
      Footer (Accepts HTML)
    </label>
    <textarea
      name="newsletter_type[footer_html]"
      id="newsletter-type-footer-html"
      v-model="footer_html"
      class="form-control"
    ></textarea>
  </div>

  <div class="form-group">
    <fieldset>
      <legend>Digest Options</legend>

      <div class="row">
        <div class="col-md-2">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-inactive"
            >
              <input type="hidden" name="newsletter_type[inactive]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-inactive"
                type="checkbox"
                name="newsletter_type[inactive]"
                v-model="inactive"
              />
              Inactive?
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-visible"
            >
              <input type="hidden" name="newsletter_type[visible]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-visible"
                type="checkbox"
                name="newsletter_type[visible]"
                v-model="visible"
              />
              Visible?
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-is-public"
            >
              <input type="hidden" name="newsletter_type[is_public]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-is-public"
                type="checkbox"
                name="newsletter_type[is_public]"
                v-model="is_public"
              />
              Is publicly accessable?
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-default-newsletter-type"
            >
              <input type="hidden" name="newsletter_type[default_newsletter_type]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-default-newsletter-type"
                type="checkbox"
                name="newsletter_type[default_newsletter_type]"
                v-model="default_newsletter_type"
              />
              Default (Subscribers)?
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-default-free-newsletter-type"
            >
              <input type="hidden" name="newsletter_type[default_free_newsletter_type]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-default-free-newsletter-type"
                type="checkbox"
                name="newsletter_type[default_free_newsletter_type]"
                v-model="default_free_newsletter_type"
              />
              Default (Free)?
            </label>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-requires-subscription"
            >
              <input type="hidden" name="newsletter_type[requires_subscription]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-requires-subscription"
                type="checkbox"
                name="newsletter_type[requires_subscription]"
                v-model="requires_subscription"
              />
              Requires an active subscription?
            </label>
          </div>
        </div>
      </div>
      <div
        class="row"
      >
        <div class="col">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-auto-subscribe"
            >
              <input type="hidden" name="newsletter_type[auto_subscribe]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-auto-subscribe"
                type="checkbox"
                name="newsletter_type[auto_subscribe]"
                v-model="auto_subscribe"
              />
              Automatically subscribe users?
            </label>
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-digest"
            >
              <input type="hidden" name="newsletter_type[digest]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-digest"
                type="checkbox"
                name="newsletter_type[digest]"
                v-model="digest"
              />
              Digest?
            </label>
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label
              class="form-check-label"
              for="newsletter-type-digestible"
            >
              <input type="hidden" name="newsletter_type[digestible]" value="false" />
              <input
                class="form-check-input"
                id="newsletter-type-digestible"
                type="checkbox"
                name="newsletter_type[digestible]"
                v-model="digestible"
                disabled
              />
              Digestible?
            </label>
            <p
              class="alert alert-info text-center"
            >
              If enabled, this newsletter type will be included in digest emails.
            </p>
          </div>
        </div>
      </div>
    </fieldset>
  </div>

  <div class="form-group" v-if="digest">
    <div class="row">
      <div class="col-4">
        <label for="newsletter-type-digest-interval-num">
          Digest Interval
        </label>
      </div>
      <div class="col-8 text-right">
        <input
          type="text"
          name="newsletter_type[digest_interval]"
          id="newsletter-type-digest-interval"
          class="form-control"
          v-model="digest_interval"
          placeholder="3.day"
        />
        <!--
        <input
          type="number"
          name="newsletter_type[digest_interval_num]"
          id="newsletter-type-digest-interval-num"
          v-model="digest_interval_num"
          placeholder="3"
        />
        <select
          name="newsletter_type[digest_interval_type]"
          id="newsletter-type-digest-interval-type"
          v-model="digest_interval_type"
        >
          <option
           value=""
          >
            Select Interval Type
          </option>
          <option
            value="day"
          >
            Days
          </option>

          <option
            value="month"
          >
            Months
          </option>
        </select>
        -->
      </div>
    </div>
    <!--
      // Currently clobbers included providers assigned via ProviderForm.
    <div
      class="row"
    >
      <div
        class="col"
      >
        <provider-picker
          :admin="true"
          label="Digestible Puzzle Types"
          selectName="newsletter_type[provider_ids][]"
          :providerIds="providerIds"
          ref="providerPicker"
        />
      </div>
    </div>
    -->
  </div>

  <div class="form-group" v-if="digest">
    <div class="row">
      <div class="col-4">
        <label for="newsletter-type-digest-wday">
          Digest Weekday
        </label>
      </div>
      <div class="col-8 text-right ">
        <weekday-select
          selectName="newsletter_type[digest_weekday]"
        />
      </div>
    </div>
  </div>
  <!-- // Currently not in use.
  <div class="form-group">
    <div
      class="row"
    >
      <div
        class="col"
      >
        <parent-newsletter-type-picker
          newsletterTypeLbl="Parent Newsletter Type"
          :newsletterTypeId="parent_newsletter_type_id"
          resource="newsletter_type"
          resourceId="parent_newsletter_type_id"
        />
      </div>
    </div>
  </div>
  -->

  <div class="form-group">
    <button
      type="submit"
      class="btn-block btn-primary form-control"
    >
      {{ newsletterTypeId ? 'Edit' : 'Create' }} Newsletter Type
      <spinner size="small" v-if="loading"></spinner>
    </button>

    <button
      type="submit"
      class="form-control btn-block btn-danger"
      v-if="newsletterTypeId"
      v-on:click.prevent="destroy"
    >
      Delete Newsletter Type
      <spinner size="small" v-if="loading"></spinner>
    </button>
  </div>
</form>
</template>

<script>
import NewsletterTypePicker from '@/components/NewsletterTypePicker'
import ProviderPicker from '@/components/ProviderPicker'
import WeekdaySelect from '@/components/utils/WeekdaySelect'

import Spinner from 'vue-simple-spinner'

import FlashStore from '@/stores/FlashStore'
import NewsletterTypeStore from '@/stores/NewsletterTypeStore'

export default {
  data () {
    let state = NewsletterTypeStore.state
    state.loading = false
    state.providerSelectedId = undefined

    return state
  },

  components: {
    'parent-newsletter-type-picker': NewsletterTypePicker,
    'provider-picker': ProviderPicker,
    'spinner': Spinner,
    'weekday-select': WeekdaySelect
  },

  computed: {
    actionUrl () {
      return this.apiUrl('/newsletter_types' + (this.newsletterTypeId ? ('/' + this.newsletterTypeId) : ''), true)
    },

    providerPickerProviders () {
      return this.$refs.providerPicker.providers
    },

    methodType () {
      return this.newsletterTypeId ? 'PUT' : 'POST'
    },

    providerIds () {
      return this.providers.map((provider) => {
        return provider['id']
      })
    }
  },

  props: ['newsletterTypeId'],

  findProvider (provider) {
    return provider.id === this.providerSelectedId
  },

  created () {
    this.sortProviders()

    this.$on('providerSelected', (provider) => {
      this.providerSelectedId = provider.id
      const providers = this.providerPickerProviders

      if (providers.length) {
        const selectedProvider = providers.find((prov) => {
          return prov.id === this.providerSelectedId
        })

        this.shouldWarnProvider(selectedProvider)
      }
    })
  },

  methods: {
    destroy () {
      // Ensure that the user is absolutely sure they want to delete the newsletter type.
      if (
        confirm(
          'Are you sure you want to delete this newsletter type? This will delete all newsletters associated with it.'
        )
      ) {
        if (confirm(
            'Please confirm one more time that you want to delete this newsletter type. This cannot be undone.'
          )
        ) {
          this.loading = true
          this.$http.delete(this.apiUrl('/newsletter_types/' + this.newsletterTypeId, true)).then((resp) => {
            this.loading = false

            this.$router.push({
              name: 'newsletter_types'
            })

            FlashStore.result('Newsletter Type \'' + this.name + '\' has been permanently deleted.')
          }, (resp) => {
            this.loading = false
            this.processErrors(resp)
          })
        }
      }
    },

    shouldWarnProvider (provider) {
      if (provider.inactive) {
        alert('This provider is inactive. Until it is activated, it will not appear.')
      }
    },

    submit (ev) {
      this.loading = true

      this.bindSubmit(ev).then((response) => {
        this.loading = false

        this.$router.push({
          name: 'newsletter_type',
          params: {
            newsletterTypeId: response.body.data.id
          }
        })

        FlashStore.result('Newsletter Type \'' + this.name + '\' has been ' + (this.newsletterTypeId ? 'updated' : 'created') + '.')
      }, (resp) => {
        this.loading = false
        this.$parent.processErrors(resp)
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeForm.vue